import { safeClone, ViewStream } from "spyne";
import { PageTraits } from "traits/page-traits";
import { PageLoadDocsTraits } from "traits/page-load-docs-traits";
import { UiBreadcrumbHolder } from "components/ui/ui-breadcrumb-holder";
import { ScrollSpyTraits } from "traits/scroll-spy-traits";
import { PageArchAsDataSlide} from 'components/pages/page-arch-as-data-slide';
import ArchAsDataTmpl from "./templates/page-architecture-as-data.tmpl.html";


export class PageArchitectureAsData extends ViewStream {
  constructor(props = {}) {
    props.traits = [PageTraits, PageLoadDocsTraits, ScrollSpyTraits];
    props.data = props.appData.archPageContent[0].content[0];
    props.id = `l1-${props.pageId}`;
    props.class = "app-page";
    props.initLoaded = false;
    props.scrollOffsetY = 100;
    props.disableScrollSpy = true;
    const len = props.appData.content.length;
    //props.data.appData =  props.appData.content[len-1];

    props.template = ArchAsDataTmpl;// require("./templates/page-docs.tmpl.html");
    super(props);
  }

  addActionListeners() {
    // return nexted array(s)
    return [
      ["CHANNEL_APP_ROUTE_PAGE_CHANGE_EVENT", "disposeViewStream"],
      /*
      ["CHANNEL_APP_ROUTE_CARD_CHANGE_EVENT", "pageLoad$OnDocsItemChanged"],
*/
      ["CHANNEL_ROUTE_DEEPLINK_EVENT", "page$ScrollSectionIntoView"],
      ["CHANNEL_ROUTE_CHANGE_EVENT", "page$ScrollSectionIntoView"],
    ];
  }

  onDeepLink(e) {
    const onScroll = () => {
      this.page$ScrollSectionIntoView(e, "auto");
    };
    // window.setTimeout(onScroll, 100);
  }

  /* onPageLoaded(e){
    if (this.props.initLoaded === true){

      this.disposeViewStream();
    } else {
      this.props.initLoaded = true;
      this.onDocsItemChanged(e, true);

    }



  }

  enableScrollSpy(){

    this.props.disableScrollSpy = false;
  }




  onDocsItemChanged(e, scrollPageBool){

    const {payload} = e;
    const pageId = payload?.pageId || payload?.routeData?.pageId;
    const {docsDataItem} = payload;
    const {srcEvent} = e?.srcElement;
    const {itemId} = docsDataItem ?? '';
    const checkToNavToItem = ()=> {
     // let itemEl$ = this.props.el$(`#${itemId}`);
      const isScrollPageEvent = scrollPageBool || srcEvent === 'click';

      //console.log('page docs item ', {payload,pageId,isScrollPageEvent, docsDataItem, e, itemId});


      if (isScrollPageEvent === true && pageId==='docs' && itemId !==undefined) {
        //console.log("ITEM IS ",itemEl$.el, {itemEl$})
        const offset = 160;
       // itemEl$.el.scrollIntoView();
       // this.props.disableScrollSpy = true;
        const scrollItem = ()=>{
         let itemEl$ =  this.props.el$(`#${itemId}`);
          //console.log("SCROLL SCTION ",itemEl$.exists === true, itemEl$.el);
          if (itemEl$?.el?.scrollIntoView) {
            itemEl$.el.scrollIntoView({block: "start"});
            window.scrollBy({top: -offset});
            //console.log("SCROLLING INTO VIEW ",itemEl$.el);
            requestAnimationFrame(this.enableScrollSpy.bind(this));
          }

        }
        requestAnimationFrame(scrollItem);
        //itemEl$.el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        //window.scrollBy({ top: -offset, behavior: 'smooth' });
       // window.setTimeout(this.enableScrollSpy.bind(this), 4000);

      }
    }

    requestAnimationFrame(checkToNavToItem);
  }
*/
  broadcastEvents1() {
    const containsLinks = this.props.el$("a").exists;
    const broadcastEls = containsLinks ? ["a", "click"] : [];
    return [broadcastEls];
  }

  /*  addPageDocItems(){
    const {pageId} = this.props;
   //console.log("PAGE IS ",pageId);
    const addPageItems = (data)=>{
     const fn = ()=> this.appendView(new PageDocsItem({data}), '.page-docs-content');
      requestAnimationFrame(fn);
    }

    this.props.data.docsContent.forEach(addPageItems);

  }*/



  addPageDocItems() {
    const addPageItems = (data) => {

      //console.log("DATA INVESTORS IS ", data);
      this.appendView(new PageDocsItem({ data }), ".page-content");
    };

    this.props.appData.archContent.forEach(addPageItems);
  }


  onRendered() {

    this.appendView(new PageArchAsDataSlide(), ".arch-section-insight");

    window.scrollTo(0, 0);
    this.addChannel("CHANNEL_APP_ROUTE", true);
    const { docsBreadcrumbData } = this.props;
    /*    this.appendView(new UiBreadcrumbHolder({
      data: docsBreadcrumbData

    }), '.breadcrumb-holder')*/

    this.prependViewToParentEl(
      new UiBreadcrumbHolder({ data: docsBreadcrumbData }),
    );
    this.page$InitPage();
    this.page$checkFor404();
    this.addPageDocItems();
   // console.log("ARCH DATA PAGE ",this.props);

   // this.pageLoad$AddPageDocItems();

    //this.scrollSpy$SubscribeAndSendToRoute();
    this.addChannel("CHANNEL_ROUTE");

    /*

    const txtData = this.props.data.spyneDocsData.docsContent[0].content[1];
    const theTmpl =3;//
    const textEl = new DomElement({
      class: 'ubu',
      data: txtData,
      template:  `<${txtData.tagName}>{{text}}</${txtData.tagName}><h1>test h1</h1>`,


    }).render();

    this.props.el.appendChild(textEl.querySelector(`div.ubu ${txtData.tagName}`));

   //console.log("this prpos data ",this.props.data.spyneDocsData.docsContent[0].content[1].text);

*/

    // this.appendView(new CodePlaygroundContainer(), "#page-header");
  }
}
